import {
  GET_SURVEY_JOB_DATA_CUT_ERROR,
  GET_SURVEY_JOB_DATA_CUT_START,
  GET_SURVEY_JOB_DATA_CUT_SUCCESS,
  SAVE_DATA_CUT_CHANGES_ERROR,
  SAVE_DATA_CUT_CHANGES_START,
  SAVE_DATA_CUT_CHANGES_SUCCESS,
  SAVE_DATA_CUT_CHANGES_RESET
} from './SurveyJobDataCutActions';

const initialState = {
  isLoadingSurveyJobDataCuts: false,
  isSavingDataCutChanges: false,
  hasErrorSavingDataCutChanges: false,
  isSavingDataCutChangesComplete: false
};

function SurveyJobDataCutsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SURVEY_JOB_DATA_CUT_START: {
      return {
        ...state,
        isLoadingSurveyJobDataCuts: true
      };
    }
    case GET_SURVEY_JOB_DATA_CUT_SUCCESS: {
      return {
        ...state,
        isLoadingSurveyJobDataCuts: false
      };
    }
    case GET_SURVEY_JOB_DATA_CUT_ERROR: {
      return {
        ...state,
        isLoadingSurveyJobDataCuts: false
      };
    }
    case SAVE_DATA_CUT_CHANGES_START: {
      return {
        ...state,
        isSavingDataCutChanges: true,
        isSavingDataCutChangesComplete: false
      };
    }
    case SAVE_DATA_CUT_CHANGES_SUCCESS: {
      return {
        ...state,
        isSavingDataCutChanges: false,
        hasErrorSavingDataCutChanges: false,
        isSavingDataCutChangesComplete: true
      };
    }
    case SAVE_DATA_CUT_CHANGES_ERROR: {
      return {
        ...state,
        isSavingDataCutChanges: false,
        hasErrorSavingDataCutChanges: true,
        isSavingDataCutChangesComplete: true
      };
    }
    case SAVE_DATA_CUT_CHANGES_RESET: {
      return {
        ...initialState
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default SurveyJobDataCutsReducer;
